import type { KeyClubDistrictAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'

const KeyClubDistrictQ = {
  ...makeQueryModelV2<KeyClubDistrictAttributes>('key_club_district')([
    'id',
    'name',
    'code',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({}),

  where: (
    {
      id,
      code,
      groupBy = null,
      include = [],
      order = null,
      paranoid = true,
    }: {
      id?: number | null | SQLFragment<number>
      code?: string | null | SQLFragment<string>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      include?: IncludeAssociations
      paranoid?: boolean
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<KeyClubDistrictAttributes> => SQL`
        FROM ${KeyClubDistrictQ}
        ${includeAssociationsToSql(KeyClubDistrictQ, include)}
        WHERE
            ${id != null ? SQL`${KeyClubDistrictQ.id} = ${id} AND` : SQL``}
            ${code != null ? SQL`${KeyClubDistrictQ.code} = ${code} AND` : SQL``}
            ${paranoid ? SQL`${KeyClubDistrictQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default KeyClubDistrictQ
